import React from "react";
import ReactDOM from "react-dom/client";
import "./index.scss";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { ProSidebarProvider } from "react-pro-sidebar";
import "bootstrap/dist/css/bootstrap.css";
import * as Sentry from "@sentry/react";
if (process.env.REACT_APP_ENVIRONMENT !== "dev") {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    // Tracing
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: [
      "localhost",
      /^https?:\/\/([a-z0-9-]+\.)?talentstrokes\.com/i,
      /^https?:\/\/([a-z0-9-]+\.)?talentstrokesqa\.com/i,
      /^https?:\/\/synoverge\.synovergetech\.in/i,
      /^https?:\/\/talentstrokes\.synovergetech\.in/i,
      /^https?:\/\/talentstrokesuat\.synovergetech\.in/i,
    ],
    environment: process.env.REACT_APP_ENVIRONMENT,
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  });
}

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  // <React.StrictMode>
  <ProSidebarProvider>
    <App />
  </ProSidebarProvider>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
